import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'PARENT_PATCH',
  PATCH_SUCCESS: 'PARENT_PATCH_SUCCESS',
  PATCH_FAILURE: 'PARENT_PATCH_FAILURE',
};

export const patch = actions.patch(parentId => `${BASE_URL}/parents/${parentId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
